import React from 'react'
import Loadable from 'react-loadable'

import LoginHigherOrder from '../common/loginComponent'
import LoadingComponent from '../common/loadingComponent'


const TMSummaryDashboard = Loadable({
  loader: () => import(/*webpackChunkName: '_ch_tm_summary'*/'./dashboard'),
  loading: () => <LoadingComponent />
});

const Dashboard = () => {
      return  <TMSummaryDashboard />  
}

export default LoginHigherOrder(Dashboard)